<template>
  <section class="ranking-card">
    <header class="ranking-card__header">
      <i class="el-icon-trophy"></i>
      <h3>Top nhân sự</h3>
    </header>
    <div class="ranking-card__body">
      <div
        v-for="(staff, index) in ranking"
        :key="staff.id"
        class="ranking-row"
        :class="{'ranking-row--first': index === 0}"
      >
        <span class="ranking-row__badge">{{ index + 1 }}</span>
        <div class="ranking-row__info">
          <strong>{{ staff.name }}</strong>
          <span>{{ staff.summary }}</span>
        </div>
        <strong class="ranking-row__score">{{ formatNumber(staff.score) }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'StaffRanking',
  props: {
    ranking: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatNumber(value) {
      return Number(value || 0).toLocaleString('vi-VN');
    }
  }
};
</script>

<style scoped lang="scss" src="./StaffRanking.scss"></style>
